import PropTypes from 'prop-types'
import { useTranslation } from 'next-i18next'

// Internal Components
import Button from '../Button/Button'
import { useContext, useEffect, useState } from 'react'
import { NavigationContext } from '@/root/context/NavigationContext'
import { UserContext } from '../../context/UserContext'

const CalendarDropdown = () => {
  const userContext = useContext(UserContext)

  // Translations
  const { t } = useTranslation(
    userContext?.userSession?.sportType?.slug ??
      process.env.NEXT_PUBLIC_RINUS_DEFAULT_NAMESPACE ??
      process.env.NEXT_PUBLIC_RINUS_DEFAULT_SPORT
  )

  // Contexts
  const navigationContext = useContext(NavigationContext)
  const [dropdownOpen, setDropdownOpen] = useState(false)

  useEffect(() => {
    // closes the menu if it's still open when the overlay is clicked.
    if (dropdownOpen && !navigationContext.dropdownOverlay) setDropdownOpen(false)
  }, [navigationContext.dropdownOverlay])

  useEffect(() => {
    navigationContext.setDropdownOverlay(dropdownOpen)
  }, [dropdownOpen])

  return (
    <div className={`CalendarDropdown ${dropdownOpen ? 'has-menu' : ''}`}>
      <Button
        label={t('CALENDAR_DROPDOWN__ADD')}
        onClick={() => setDropdownOpen(!dropdownOpen)}
        icon={{ id: 'icon-add' }}
        modifiers={['Button--calendarNavigation Button--calendarDropdown']}
      />
      <div className="CalendarDropdown-content">
        <Button
          label={t('CALENDAR_DROPDOWN__TRAINING')}
          modal={{ type: 'api', route: 'create/blueprint/open' }}
          onClick={() => {
            navigationContext.setDropdownOverlay(false)
            setDropdownOpen(!dropdownOpen)
          }}
          modifiers={['Button--calendarNavigation']}
        />
        <Button
          label={t('CALENDAR_DROPDOWN__MATCH')}
          modal={{ type: 'api', route: 'create/match/open' }}
          onClick={() => {
            navigationContext.setDropdownOverlay(false)
            setDropdownOpen(!dropdownOpen)
          }}
          modifiers={['Button--calendarNavigation']}
        />
      </div>
    </div>
  )
}

CalendarDropdown.propTypes = {
  currentSection: PropTypes.any
}

export default CalendarDropdown
